import { render, staticRenderFns } from "./PartnersTabLinks.vue?vue&type=template&id=6d37caed"
import script from "./PartnersTabLinks.vue?vue&type=script&lang=js"
export * from "./PartnersTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports